/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ButtonComponent, TooltipDirective } from '@ods/system';
import { DecisionDialogComponent } from '../decision-dialog/decision-dialog.component';
import { DecisionDialogConfig, TriggerButtonConfig } from './decision-dialog-button.model';

@Component({
  selector: 'odc-decision-dialog-button',
  imports: [ButtonComponent, TooltipDirective, DecisionDialogComponent],
  templateUrl: './decision-dialog-button.component.html',
})
export class DecisionDialogButtonComponent {
  public readonly buttonConfig: InputSignal<TriggerButtonConfig> = input.required<TriggerButtonConfig>();
  public readonly dialogConfig: InputSignal<DecisionDialogConfig> = input.required<DecisionDialogConfig>();

  public readonly apply: OutputEmitterRef<void> = output<void>();
}
